import styled from "styled-components";

import { colors } from "../../../constants/colors";

export type StyledMultiInputAreaProps = {
  height?: string;
  width?: string;
  padding?: string;
};

export const StyledMultiInputArea = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  background: ${colors.form.background};
  height: ${({ height }: StyledMultiInputAreaProps) => height || "6rem"};
  width: ${({ width }: StyledMultiInputAreaProps) => width || "10rem"};
  padding: ${({ padding }: StyledMultiInputAreaProps) => padding || "0"};
  border-radius: 1px;
  border: 0px;
  resize: none;

  p.default {
    color: ${colors.silver};
  }
`;
